import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tournament-list" }
const _hoisted_2 = { class: "text-capitalize-first" }
const _hoisted_3 = { class: "tabs header-content" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "header ms-0" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "d-flex flex-column header-content gap-sm" }
const _hoisted_10 = { class: "header ms-0" }
const _hoisted_11 = { class: "text-capitalize-first" }
const _hoisted_12 = { class: "d-flex flex-column header-content gap-sm" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "d-flex flex-column header-content gap-sm" }

import {reactive} from "@vue/reactivity";
import TournamentDTO from "@/models/TournamentDTO";
import {api} from "@/service/APIClient";
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import TournamentCard from "@/components/tournaments/TournamentCard.vue";
import {TournamentStatus} from "@/models/enum/TournamentStatus";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TournamentAchievementDTO from "@/models/TournamentAchievementDTO";
import LoaderContent from "@/components/LoaderContent.vue";
import store from "@/store";
import {useRoute, useRouter} from "vue-router";

enum Tabs {
  main = 'main',
  achievements = 'achievements',
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Tournaments',
  setup(__props) {

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const router = useRouter();
const route = useRoute();

const state = reactive({
  tab: (route.params.tab ? route.params.tab :  Tabs.main) as Tabs,
  achievements: {
    limit: 10,
    offset: 0,
    totalCount: 0,
    items: []
  } as PaginatedResponseDTO<TournamentAchievementDTO>,
  nowUpdateInterval: null as number|any,
  liveUpdateInterval: null as number|any,
  now: Date.now() as number
});

const activeTournaments = computed(() => {
  return store.getters.liveTournaments.filter((item) => item.status === TournamentStatus.ACTIVE)
})

const upcomingTournaments = computed(() => {
  return store.getters.liveTournaments.filter((item) => item.status === TournamentStatus.ANNOUNCEMENT)
})

const loadAchievements = (offset: number) => {
  state.achievements.offset = offset
  loader.value?.load(async () => {
    const resp = await api.call.tournaments.achievements(state.achievements)
    if (offset === 0) {
      state.achievements = resp
    } else {
      state.achievements.items = state.achievements.items.concat(resp.items);
    }
  })
}

watch(() => loader.value, async (newValue, oldValue) => {
  if (!store.getters.isLoggedIn) {
    router.push({name: 'login'})
    return;
  }
  loadAchievements(0)
})

onMounted(async () => {
  await store.dispatch('setLiveTournaments', await api.call.live.tournaments());

  state.nowUpdateInterval = setInterval(() => {
    state.now = Date.now();
  }, 1000);
  state.liveUpdateInterval = setInterval(async () => {
    api.call.live.tournaments().then((resp) => store.dispatch('setLiveTournaments', resp))
  }, 10000);
});

const selectTab = (tab: Tabs) => {
  state.tab = tab
  router.replace({name: 'tournaments', params: {tab: tab}})
}

onUnmounted(() => {
  clearInterval(state.nowUpdateInterval);
  clearInterval(state.liveUpdateInterval);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('tournaments')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(Tabs), (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab,
          type: "button",
          onClick: ($event: any) => (selectTab(tab)),
          class: _normalizeClass(["btn btn-tab", [_unref(state).tab === tab ? 'btn-primary' : '']])
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(`${tab}`)), 1)
        ], 10, _hoisted_4))
      }), 128))
    ]),
    (_unref(state).tab === Tabs.main)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('active')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeTournaments.value, (item, index) => {
              return (_openBlock(), _createBlock(TournamentCard, {
                item: item,
                key: item.id,
                now: _unref(state).now
              }, null, 8, ["item", "now"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('upcoming')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(upcomingTournaments.value, (item, index) => {
              return (_openBlock(), _createBlock(TournamentCard, {
                item: item,
                key: item.id,
                now: _unref(state).now
              }, null, 8, ["item", "now"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(state).tab === Tabs.achievements)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(LoaderContent, {
            ref: (el) => loader.value = el
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).achievements.items, (item, index) => {
                  return (_openBlock(), _createBlock(TournamentCard, {
                    item: item.tournament,
                    participant: item.participant,
                    key: item.tournament.id,
                    now: _unref(state).now
                  }, null, 8, ["item", "participant", "now"]))
                }), 128)),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (loadAchievements(_unref(state).achievements.offset + _unref(state).achievements.limit)), ["prevent"])),
                  class: "btn btn-outline-secondary w-100"
                }, _toDisplayString(_ctx.$t('show_more')), 1)
              ])
            ]),
            _: 1
          }, 512)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})